/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import { ModelTreeNode, ParsedTreeNodeType } from '../../modelConfiguration/data/modelOptionsTree';
import { TreeSelections } from '../../modelConfiguration/data/treeSelection';
import { LayoutUtil } from '../../modelConfiguration/logic/layoutUtil';
import { ModelConfigurationLinearNodeContainer } from './modelConfigurationLinearNodeContainer';
import { ModelConfigurationLinearNode } from './modelConfigurationLinearNode';
import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';

interface ModelConfigurationTreeGroupContainerProps {
  node : ModelTreeNode,
  treeSelectionState: TreeSelections,
  tagsTranslation : CatalogTagsTranslation[],
  languageSelected : string,
  updateTreeSelectionState: (selection: TreeSelections) => void,
  updateOptionSelection: (groupID : number, optionID : number) => void,
  getResourcePath(path: string): string,
}

export function ModelConfigurationLinearGroupContainer(
  {
    node,
    treeSelectionState,
    tagsTranslation,
    languageSelected,
    updateTreeSelectionState,
    updateOptionSelection,
    getResourcePath,
  } : ModelConfigurationTreeGroupContainerProps,
) : JSX.Element {

  const renderChildrenThatAreOptions = () : JSX.Element => {

    const nodeSelection = treeSelectionState.find((selection) => {
      return selection.path === node.path;
    });

    let optionSelectedName = '';
    if (nodeSelection) {
      const optionSelectedFullPath = nodeSelection.value;

      // Remove the path of the node from the full path
      // The +1 is to remove the last separator
      const parentPathLen = node.path.length + 1;

      // Get Child selected Node or Get the text after the parentPathLen
      const selectedNode = node.children.find((childnode) => childnode.path === optionSelectedFullPath);
      optionSelectedName = CatalogTagsTranslation.getTranslation(selectedNode?.tagTranslation, languageSelected) || optionSelectedFullPath.slice(parentPathLen);
    }

    return (
      <>
        <ModelConfigurationLinearNodeContainer
          node={node}
          treeSelectionState={treeSelectionState}
          updateTreeSelectionState={updateTreeSelectionState}
          updateOptionSelection={updateOptionSelection}
          getResourcePath={getResourcePath}
          languageSelected={languageSelected}
        />
        {
          (!node.singleOptionParent && optionSelectedName !== '') && (
            <div className="option-selected-name">
              {optionSelectedName}
            </div>
          )
        }
      </>
    );
  };

  const renderChildrenThatAreDomainGroups = () : JSX.Element => {

    // If the children are folders, we should ask if they have a node to be shown
    // If they do, we'll show it
    const nodeSelection = treeSelectionState.find((selection) => {
      return selection.path === node.path;
    });

    let optionSelectedName = '';
    if (nodeSelection) {
      const optionSelectedFullPath = nodeSelection.value;

      // Remove the path of the node from the full path
      // The +1 is to remove the last separator
      const parentPathLen = node.path.length + 1;

      // Get the text after the parentPathLen
      const selectedNode = node.children.find((childnode) => childnode.path === optionSelectedFullPath);
      optionSelectedName = CatalogTagsTranslation.getTranslation(selectedNode?.tagTranslation, languageSelected) || optionSelectedFullPath.slice(parentPathLen);
    }

    let folderContents : JSX.Element | null = null;

    for (let i = 0; i < node.children.length; i += 1) {

      const child = node.children[i];

      const shouldShowFolderContents = LayoutUtil.shouldFolderContentBeShown(
        node.path,
        child.path,
        treeSelectionState,
      );

      if (shouldShowFolderContents) {

        folderContents = (
          <ModelConfigurationLinearGroupContainer
            node={child}
            treeSelectionState={treeSelectionState}
            tagsTranslation={tagsTranslation}
            languageSelected={languageSelected}
            updateTreeSelectionState={updateTreeSelectionState}
            updateOptionSelection={updateOptionSelection}
            getResourcePath={getResourcePath}
          />
        );

        // Since only one folder at a time, will show anything, we can
        // break the loop as soon as we have something to show
        break;
      }
    }

    return (
      <>
        <ModelConfigurationLinearNodeContainer
          node={node}
          treeSelectionState={treeSelectionState}
          updateTreeSelectionState={updateTreeSelectionState}
          updateOptionSelection={updateOptionSelection}
          getResourcePath={getResourcePath}
          languageSelected={languageSelected}
        />
        {
          (!node.singleOptionParent && optionSelectedName !== '') && (
            <div className="option-selected-name">
              {optionSelectedName}
            </div>
          )
        }
        {folderContents}
      </>
    );
  };

  const renderChildrenThatAreFolders = () : JSX.Element => {

    // If the children are folders, we should ask if they have a node to be shown
    // If they do, we'll show it
    const nodeSelection = treeSelectionState.find((selection) => {
      return selection.path === node.path;
    });

    let optionSelectedName = '';
    if (nodeSelection) {
      const optionSelectedFullPath = nodeSelection.value;

      // Remove the path of the node from the full path
      // The +1 is to remove the last separator
      const parentPathLen = node.path.length + 1;

      // Get the text after the parentPathLen
      const selectedNode = node.children.find((childnode) => childnode.path === optionSelectedFullPath);
      optionSelectedName = CatalogTagsTranslation.getTranslation(selectedNode?.tagTranslation, languageSelected) || optionSelectedFullPath.slice(parentPathLen);
    }

    let folderContents : JSX.Element | null = null;

    for (let i = 0; i < node.children.length; i += 1) {

      const child = node.children[i];

      const shouldShowFolderContents = LayoutUtil.shouldFolderContentBeShown(
        node.path,
        child.path,
        treeSelectionState,
      );

      if (shouldShowFolderContents) {

        folderContents = (
          <ModelConfigurationLinearGroupContainer
            node={child}
            treeSelectionState={treeSelectionState}
            tagsTranslation={tagsTranslation}
            languageSelected={languageSelected}
            updateTreeSelectionState={updateTreeSelectionState}
            updateOptionSelection={updateOptionSelection}
            getResourcePath={getResourcePath}
          />
        );

        // Since only one folder at a time, will show anything, we can
        // break the loop as soon as we have something to show
        break;
      }
    }

    return (
      <>
        <ModelConfigurationLinearNodeContainer
          node={node}
          treeSelectionState={treeSelectionState}
          updateTreeSelectionState={updateTreeSelectionState}
          updateOptionSelection={updateOptionSelection}
          getResourcePath={getResourcePath}
          languageSelected={languageSelected}
        />
        {
          (!node.singleOptionParent && optionSelectedName !== '') && (
            <div className="option-selected-name">
              {optionSelectedName}
            </div>
          )
        }
        {folderContents}
      </>
    );
  };

  const renderChildrenThatAreGroups = () : JSX.Element => (
    <>
      {
        node.children.map((child) => {

          let childContainer : JSX.Element;

          if (child.type === ParsedTreeNodeType.Group
              || child.type === ParsedTreeNodeType.Domain) {

            childContainer = (
              <ModelConfigurationLinearGroupContainer
                node={child}
                treeSelectionState={treeSelectionState}
                tagsTranslation={tagsTranslation}
                languageSelected={languageSelected}
                updateTreeSelectionState={updateTreeSelectionState}
                updateOptionSelection={updateOptionSelection}
                getResourcePath={getResourcePath}
              />
            );
          } else {
            childContainer = (
              <div>
                No container defined for type
                {' '}
                {child.type}
              </div>
            );
          }

          return (
            <React.Fragment
              key={child.name}
            >
              <ModelConfigurationLinearNode
                node={child}
                pathParent={node.path}
                pathNode={child.path}
                treeSelectionState={treeSelectionState}
                updateTreeSelectionState={updateTreeSelectionState}
                updateOptionSelection={updateOptionSelection}
                getResourcePath={getResourcePath}
                languageSelected={languageSelected}
              />
              {childContainer}
            </React.Fragment>
          );
        })
      }
    </>
  );

  const renderChildren = () : JSX.Element => {

    const childrenType = LayoutUtil.getChildrenType(node);

    if (childrenType.childrenAreOptions) {
      return renderChildrenThatAreOptions();
    }

    if (childrenType.childrenAreFolders) {
      return renderChildrenThatAreFolders();
    }

    if (childrenType.childrenAreDomainGroups) {
      return renderChildrenThatAreDomainGroups();
    }

    if (childrenType.childrenAreGroups) {
      return renderChildrenThatAreGroups();
    }

    return (
      <div>
        Do not know how to represent this yet
        <div
          style={{
            fontSize: '7pt',
            fontStyle: 'italic',
          }}
        >
          <div>
            childrenAreOptions =
            {' '}
            {childrenType.childrenAreOptions ? '1' : '0'}
          </div>
          <div>
            childrenAreFolders =
            {' '}
            {childrenType.childrenAreFolders ? '1' : '0'}
          </div>
          <div>
            childrenAreDomains =
            {' '}
            {childrenType.childrenAreDomains ? '1' : '0'}
          </div>
          <div>
            childrenAreDomainGroups =
            {' '}
            {childrenType.childrenAreDomainGroups ? '1' : '0'}
          </div>
          <div>
            childrenAreGroups =
            {' '}
            {childrenType.childrenAreGroups ? '1' : '0'}
          </div>
        </div>
      </div>
    );
  };

  return (
    renderChildren()
  );
}
